import React, { useState } from 'react';
import { withFormik, FormikProps } from 'formik';
import { IntlShape, injectIntl } from 'react-intl';
import { ProfileSettingsInfoType } from 'store/user/types';
import { OrangeButton } from 'components/Button';
import MyPreferences from 'containers/MyAccountPage/MyPreferences';
import About from 'containers/MyAccountPage/About';
import PersonalInfo from 'containers/MyAccountPage/PersonalInfo';
import messages from 'containers/MyAccountPage/messages';
import { get, isEmpty } from 'lodash';
import { translate } from 'helpers/intl';
import validationSchema from 'containers/MyAccountPage/validationSchema';
import ConfirmPasswordModal from 'components/ConfirmPasswordModal';
import { correctDateForm } from 'utils/string';

const ChangePasswordForm = (
  props: {
    profileSettingsInfo: ProfileSettingsInfoType;
    isLoading: boolean;
  } & FormikProps<FormValues>,
) => {
  const {
    values,
    touched,
    errors,
    handleChange,
    handleBlur,
    profileSettingsInfo,
    handleSubmit,
  } = props;

  const [isConfirmPasswordModalOpen, setIsConfirmPasswordModalOpen] = useState(
    false,
  );

  function handleSubmitPassword() {
    handleSubmit();
    setIsConfirmPasswordModalOpen(false);
  }

  function saveUpdatesDisable() {
    return (
      isEmpty(touched) &&
      get(profileSettingsInfo, 'phone') === get(values, 'phoneNumber') &&
      get(profileSettingsInfo, 'email') === get(values, 'email') &&
      get(profileSettingsInfo, 'birthday') === get(values, 'bday')
    );
  }

  return (
    <form>
      <PersonalInfo
        firstName={profileSettingsInfo.firstName}
        lastName={profileSettingsInfo.lastName}
        cin={profileSettingsInfo.cin}
        values={values}
        handleChange={handleChange}
        handleBlur={handleBlur}
        touched={touched}
        errors={errors}
      />
      <MyPreferences handleChange={handleChange} values={values} />
      <About />
      <OrangeButton
        variant="contained"
        onClick={() => setIsConfirmPasswordModalOpen(true)}
        disabled={saveUpdatesDisable()}
      >
        {translate(get(messages, 'saveChanges'), props)}
      </OrangeButton>
      <ConfirmPasswordModal
        isOpen={isConfirmPasswordModalOpen}
        handleClose={() => setIsConfirmPasswordModalOpen(false)}
        error={touched.password && errors.password}
        helperText={touched.password && errors.password}
        handleChange={handleChange}
        handleBlur={handleBlur}
        value={values.password}
        handleSubmit={handleSubmitPassword}
        isLoading={props.isLoading}
      />
    </form>
  );
};

export interface FormProps {
  intl: IntlShape;
  profileSettingsInfo: ProfileSettingsInfoType;
  updateProfileSettingsInfo: Function;
  isLoading: boolean;
}

interface FormValues {
  birthday: string;
  phoneNumber: string;
  email: string;
  password: string;
}

const Form = withFormik<FormProps, FormValues>({
  mapPropsToValues: (props) => {
    return {
      birthday: correctDateForm(props.profileSettingsInfo.bday),
      phoneNumber: props.profileSettingsInfo.phone,
      email: props.profileSettingsInfo.email,
      language: props.profileSettingsInfo.language,
      isNotifEnabled: props.profileSettingsInfo.isNotifEnabled,
      password: '',
    };
  },
  validationSchema,
  handleSubmit: (values, { props }) => {
    const dataToSend = {
      telephone: values.phoneNumber,
      password: values.password,
      changedEmail: values.email,
      bday: values.birthday,
    };
    props.updateProfileSettingsInfo(dataToSend);
  },
})(ChangePasswordForm);

export default injectIntl(Form);
